module.exports = __webpack_public_path__ + "static/media/tut-2.c7474ccc.png";